"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _program = require("@studio/program");
var _setProgramRealtime = _interopRequireDefault(require("./setProgramRealtime"));
var _sendToDatadogWithIds = require("../../utils/sendToDatadogWithIds");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * Builds a new scene replacing previous source values for a supplied source.
 *
 * This allows us to keep a scene unchanged except for a source that's changed, for example an audio source that has
 * changed from `muted: false` to `muted: true`.
 */
var _default = exports["default"] = function _default(changedSource) {
  var realtime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var setProgramCb = arguments.length > 2 ? arguments[2] : undefined;
  return function (dispatch, getState) {
    var _getState = getState(),
      program = _getState.program;
    var nextScene = _objectSpread({}, program);
    var currentLayers = (0, _program.getProgramLayers)(program);
    nextScene.layers = currentLayers.map(function (layerSource) {
      var source = layerSource.source;
      if ((source === null || source === void 0 ? void 0 : source._id) === changedSource._id) {
        return _objectSpread(_objectSpread({}, layerSource), {}, {
          source: changedSource
        });
      }
      return layerSource;
    });
    if (realtime) {
      return dispatch((0, _setProgramRealtime["default"])(nextScene));
    }
    (0, _sendToDatadogWithIds.logProgramChange)(getState, 'setSourceChangesToProgram action');
    setProgramCb && setProgramCb(nextScene);
  };
};